// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__8UXId"};